import { render, staticRenderFns } from "./JournalFormHeader.vue?vue&type=template&id=5b6e3c3c&"
import script from "./JournalFormHeader.vue?vue&type=script&lang=js&"
export * from "./JournalFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports